//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import ForwardIcon from "@material-ui/icons/Forward";

import UploadFileWithConfigurationButton from "src/components/loader/buttons/UploadFileWithConfigurationButton";

const ConvertXmlXerButton = (props) => {
    return (
        <UploadFileWithConfigurationButton
            label="Convert XML/XER"
            url="loader/convertFile"
            icon={<ForwardIcon />}
            {...props}
        />
    );
};
export default ConvertXmlXerButton;
